import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import UrlModal from "./UrlModal";

const GeneratePayment = () => {
    const [isLoading, setIsLoading] = useState("");
    const [error, setError] = useState("");
    const [avilableServiceName, setavilableServiceName] = useState([]);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [amount, setAmount] = useState(0);
    const [plan_months, setPlanMonths] = useState(0);
    const [selectedService, setSelectedService] = useState({ id: 0, name: "" }); // Store both ID and name
    const [phoneError, setPhoneError] = useState("");
    const [gurlid, setgurlid] = useState("");
    const [serviceName, setserviceName] = useState("");
    const [openModal, setOpenModal] = useState(false);
    

    const handleDisplayService = async () => {
        try {
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/get_all_products', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);
                setavilableServiceName(data);
                if (data.length > 0) {
                    setSelectedService({ id: data[0].id, name: data[0].name });
                }
            } else {
                throw new Error('Failed to post data');
            }
        } catch (err) {
            console.error('Error getting data:', err);
        }
    };

    useEffect(() => {
        handleDisplayService();
    }, []);

    const handlePhoneChange = (e) => {
        // setPhoneError("");
        const value = e.target.value.replace(/[^0-9]/g, ''); // Allow only numbers
        setPhone(value);

        // Check if the length is exactly 10
        if (value.length > 10) {
            setPhoneError("Phone number cannot exceed 10 digits");
        } else if (value.length < 10) {
            setPhoneError("Phone number must be exactly 10 digits");
        } else {
            setPhoneError("");
        }
    };

    const handleGeneratePayment = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        if (name.trim() === "" || email.trim() === "" || phone.trim() === "" || amount <= 0 || plan_months <= 0) {
            setError("Please fill in all fields correctly");
            setIsLoading(false);
            return;
        }
        try {
            const response = await fetch('https://apiroutetapxtream.invtechnologies.in/create_payment_service', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "user_name": name,
                    "email": email,
                    "phone_no": phone,
                    "product_id": selectedService.id,
                    "payment_status": "Pending",
                    "amount": amount,
                    "plan_months": plan_months,
                    "service_name": selectedService.name,
                }),
            });
            if (response.ok) {
                const data = await response.json();
                // console.log(data);

                setgurlid(data.genarate_id);
                setserviceName(data.service_name);
                setError("Payment Link generated Successfully");
                setName("");
                setEmail("");
                setPhone("");
                setAmount(0);
                setPlanMonths(0);
                setPhoneError("");
                setSelectedService({ id: 0, name: "" });
                setOpenModal(true);
            } else {
                setError('Failed to post data, Mail & service already exists');
                throw new Error('Failed to post data, Mail & service already exists');
            }
        } catch (err) {
            console.error('Error getting data:', err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <Box sx={{
            p: 2,
            width: "320px",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            backgroundColor: "white",
            borderRadius: "10px"
        }}>
            <form onSubmit={handleGeneratePayment}>
                <TextField
                    placeholder="Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <TextField
                    placeholder="Email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                />
                <TextField
                    placeholder="Phone"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={phone}
                    onChange={handlePhoneChange}
                    error={!!phoneError}
                    helperText={phoneError}
                />

                <Typography sx={{ mt: 1, fontWeight: "bold" }}>Amount</Typography>
                <TextField
                    placeholder="Amount"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={amount}
                    onChange={(e) => setAmount(parseInt(e.target.value.replace(/[^0-9]/g, ''), 10) || 0)} // Convert to integer
                />

                <Typography sx={{ mt: 1, color: "black", fontWeight: "bold" }}>Plan Months</Typography>
                <TextField
                    placeholder="Plan Months"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={plan_months}
                    onChange={(e) => setPlanMonths(parseInt(e.target.value.replace(/[^0-9]/g, ''), 10) || 0)} // Convert to integer
                />
                <Typography sx={{ mt: 1, color: "black", fontWeight: "bold" }}>Service Type</Typography>

                <Select
                    value={selectedService.id} // Use selected service ID
                    onChange={(e) => {
                        const selected = avilableServiceName.find(service => service.id === parseInt(e.target.value, 10));
                        if (selected) {
                            setSelectedService({ id: selected.id, name: selected.name }); // Set both ID and name
                        }
                    }} // Update both ID and name
                    fullWidth
                    margin="normal"
                >
                    {avilableServiceName.map((service) => (
                        <MenuItem key={service.id} value={service.id}>
                            {service.name}
                        </MenuItem>
                    ))}
                </Select>

                {error && (
                    <Typography color="error" sx={{ fontSize: "0.875rem", mt: 1 }}>
                        {error}
                    </Typography>
                )}

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={isLoading}
                    sx={{
                        mt: 2,
                        // fontSize: { xs: "0.875rem", md: "1rem" } 
                        fontWeight: "bold"
                    }}
                >
                    {isLoading ? "Generating..." : "Generate Payment"}
                </Button>
            </form>
            <UrlModal open={openModal} onClose={handleCloseModal} gurlid={gurlid} serviceName={serviceName}/>
        </Box>
    )
};
export default GeneratePayment;